import { render, staticRenderFns } from "./perfil-empresa.vue?vue&type=template&id=64bde5a0&scoped=true&"
import script from "./perfil-empresa.vue?vue&type=script&lang=js&"
export * from "./perfil-empresa.vue?vue&type=script&lang=js&"
import style0 from "./perfil-empresa.vue?vue&type=style&index=0&id=64bde5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bde5a0",
  null
  
)

export default component.exports